import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import Grid from "../../../../components/Grid";
import {sanPortDetail} from "../../../../utils/gridColumnDefs/switches/switchesSummary";
import {useSearchParams} from "react-router-dom";
import {Card} from "reactstrap";

export default function SANPortDetail({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const [searchParams] = useSearchParams();
    const { theme, client, periodId } = useVsiAppContext();

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/switch_zone_detail_proc?client_id=${client.clientId}&period_id=${periodId}&switch_name=${searchParams.get("switch_name")}`)

    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        setChartData(data?.recordset);
    }, [data]);

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>SAN Port Detail - {searchParams.get("switch_name")}</VsiH4>
            <VsiBubble>
                <Grid addStyle data={chartData}
                      columnDefs={sanPortDetail}
                      isLoading={isLoading}/>
            </VsiBubble>
        </Card>
    )
}
